'use client'
import { ReactNode } from 'react'

import { Locale } from '@/i18n'

import { I18nContext, type Dictionary } from './i18n-context'

export function I18nProvider({
  children,
  locale,
  dictionary,
}: {
  children: ReactNode
  dictionary: Dictionary
  locale: Locale
}) {
  return <I18nContext.Provider value={{ dictionary, locale }}>{children}</I18nContext.Provider>
}
